/* eslint-disable no-undef */
import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import * as userActions from "../../actions/userActions";
import * as settingActions from "../../actions/settingActions";
import * as homePageActions from "../../actions/homePageActions";
// Import Redux Toolkit slice actions
import {
  loadLeaderData,
  loadTestimonialsData,
  loadCommunityData,
  getBrandData,
  sendEmailForVerification
} from "./Slice/homeSlice";
import { Container, Row, Col, Form, FormControl } from "react-bootstrap";
import Button from "../../Component/Button";
import { Link, useNavigate } from "react-router-dom";
import Slider from "react-slick";
import Video from "./video";
import { agent } from "../../utils/agent";
import * as API from "../../utils/apiPath";
import { useForm } from "react-hook-form";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";
import Subscribe from "../../Component/Subscribe/index";
import Popup from "../../Component/Popup/index";
import playBox from '../../assets/images/playBox.jpg'
import ReadMoreParagraph from "../../Component/ReadMore";
import PopupModalWithOk from "../../utils/helpers/popupModalOk";
import useResponsive from "./Hooks/useMobile";
import PropTypes from "prop-types";
import { getSubdomainPath } from "../../utils/helpers";

const Index = (props) => {
  const { actions, setting, brand, homePageData, leaders, testimonials, community, userInfo } = props;
  const [modalShow, setModalShow] = useState(false);
  const [signupModalShow, setSignupModalShow] = useState(false);
  const { register: register2, handleSubmit: handleSubmit2, reset: reset2, formState: { errors: errors2 } } = useForm({});

  const [popUpLoader, setPopUpLoader] = useState(false)
  const [popupMessage, setPopupMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const { isMobile, isTablet, isSmallLaptop } = useResponsive();

  const [ssoLoading, setSsoLoading] = useState(false);

  const history = useNavigate();
  const dispatch = useDispatch();

  const prepareHtml = (description) => {
    return { __html: description || "" };
  };

  const joinGroupDetail = (e, community_slug) => {
    e.preventDefault();
    history(`/community-details/${community_slug}`);
  };


  useEffect(() => {
    const fetchData = () => {
      // Fetch settings from old reducer (this is what's being used)
      actions.getSettingData();
      // Use Redux Toolkit slice actions
      actions.getBrandData();
      actions.loadHomePageData("home");
      actions.loadLeaderData(10);
      actions.loadTestimonialsData(10);
      actions.loadCommunityData(10);
    };
    fetchData();
  }, [actions, dispatch]);

  const siteName = setting?.name?.trim() || "";

  useEffect(() => {
    const title = `${siteName} - Home`;
    document.title = title;
  }, [siteName]);

  useEffect(() => {
    if (!setting?.id) return;
    const alreadyRedirected = sessionStorage.getItem("fusionauthRedirect");
    // If we already redirected once in this session → do nothing
    // if (alreadyRedirected) {
    //   setSsoLoading(false);
    //   return;
    // }

    if (setting?.is_sso_enable === "1") {
      const fusionAuthUrl = setting?.fusionauth_url;
      const savedRole = localStorage.getItem("userRole");

      if (!userInfo?.role_id && !savedRole && !alreadyRedirected) {
        sessionStorage.setItem("fusionauthRedirect", "true");
        setSsoLoading(true);

        if (fusionAuthUrl) {
          // Delay the redirect slightly so the spinner has time to render
          setTimeout(() => {
            globalThis.location.href = fusionAuthUrl;
          }, 500);
        } else {
          console.warn("SSO redirect URL missing (setting.fusionauth_url)");
          setSsoLoading(false);
        }
      }
    }
  }, [setting, userInfo]);

  const onSubmitEmail = async (data) => {
    try {
      const checkRes = await agent.get(API.checkInvitationEMail + "/" + data?.email);

      // true → email not found → safe to subscribe
      if (checkRes.data.data === true) {
        const subscribeRes = await agent.post(API.SAVESUBSCRIBTIONEMAIL, data);
        setPopupMessage(
          subscribeRes?.data?.message || "Subscribed successfully!"
        );
        setShowPopup(true);
        reset2({ email: "" });
        return;
      }
      if (checkRes.data.data === false) {
        setPopupMessage(checkRes.data.message || "Email already registered.");
        setShowPopup(true);
        reset2({ email: "" });
      }
    } catch (err) {
      console.error("Email check failed:", err);
      setPopupMessage(err.response?.data?.message || "Something went wrong.");
      setShowPopup(true);
    }
  };

  const handleSubmitCheckEmail = async (data) => {
    try {
      setPopUpLoader(true);

      // non-SSO fallback
      const action = await dispatch(sendEmailForVerification(data));
      const result = action.payload;

      if (result?.data?.sso_verifed) {
        setSignupModalShow(false);
        history("/manage-profile");
      } else {
        setSignupModalShow(false);
        setPopupMessage(result?.message || "Verification email sent successfully!");
        setShowPopup(true);
      }

    } catch (err) {
      setPopupMessage(
        err?.payload?.message ||
        err?.message ||
        "Failed to send verification email."
      );
      setShowPopup(true);
    } finally {
      setPopUpLoader(false);
    }
  };

  const getSlidesToShow = (desktopValue) => {
    if (isMobile) return 1;
    if (isTablet) return 2;
    if (isSmallLaptop) return 3;
    return desktopValue;
  };

  const leadersSilder = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToScroll: 1,
    slidesToShow: getSlidesToShow(4),
  };
  const TestimonialsSilder = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToScroll: 3,
    nextArrow: null,
    prevArrow: null,
    slidesToShow: getSlidesToShow(3),
  };
  const communities = {
    dots: false,
    infinite: false,
    speed: 500,
    arrows: true,
    autoplay: true,
    slidesToScroll: 1,
    slidesToShow: getSlidesToShow(3),
  };

  const Brand = {
    dots: false,
    infinite: false,
    speed: 500,
    prevArrow: null,
    nextArrow: null,
    slidesToScroll: 1,
    slidesToShow: getSlidesToShow(5),
  };

  const moduleRenderData = setting?.module_data

  const isSectionShow = (name) => {
    return moduleRenderData?.some((item) => item?.name == name && item?.status == "Enabled" && item?.is_default == "Yes")
  }

  const isSectionEnabled = (parentName, childName = null) => {
    if (!moduleRenderData?.length) return true; // fallback safety

    return moduleRenderData.some((parent) => {
      if (
        parent.name === parentName &&
        parent.status === "Enabled" &&
        parent.is_default === "Yes"
      ) {
        // If no child required → just check parent
        if (!childName) return true;

        // Check child inside parent
        return parent.children?.some(
          (child) =>
            child.name === childName &&
            child.status === "Enabled" &&
            child.is_default === "Yes"
        );
      }
      return false;
    });
  };

  const getSignupPopup = () => {
    if (setting?.email_approval_required === 1) {
      setSignupModalShow(true);
      return;
    }
    history({ pathname: "/register" });
  };

  const getFieldValueAndStatus = (field) => {
    return setting?.mentor_fields_json?.find(item => item.field === field)?.value === "Yes";
  };

  const [expandedItems, setExpandedItems] = useState({});

  const toggleExpand = (key) => {
    setExpandedItems((prevState) => ({
      ...prevState,
      [key]: !prevState[key],
    }));
  };

  const subdomainPath = getSubdomainPath();

  return (
    <>
      <section id="home" className="home_banner_block d-flex">
        <Container>
          <Row className={`align-items-center`}>
            <Col md={7} className="order-2 order-md-1">
              <div className="banner_content pt-2 pt-md-0">
                {setting?.home_page_hedding_enable === "1" && (
                  <div className="banner_title  text-md-start" dangerouslySetInnerHTML={prepareHtml(setting?.heading?.replaceAll("\r\n", "<br>"))} />
                )}
                {setting?.home_page_sub_hedding_enable === "1" && (
                  <p dangerouslySetInnerHTML={prepareHtml(setting?.sub_heading?.replaceAll("\r\n", "<br>"))}></p>
                )}
                <div className="caption_Secondary">
                  {setting?.punch_line_enable === "1" && (
                    <strong dangerouslySetInnerHTML={prepareHtml(setting?.punch_line?.replaceAll("\r\n", "<br>"))}></strong>
                  )}
                  {setting?.is_sso_enable !== "1" && !userInfo?.id && (
                    <Link
                      onClick={getSignupPopup}
                      to="#"
                      className="btn px-4 me-2"
                    >
                      Sign Up{" "}
                      <span className="ms-2 verticle-middle mt-1">
                        <img src="assets/images/whiteArrow.svg" alt="" />
                      </span>
                    </Link>
                  )}
                  {setting?.is_sso_enable === "1" && !userInfo?.role_id && (
                    <Link
                      onClick={getSignupPopup}
                      to="#"
                      className="btn px-4"
                    >
                      Create My Profile{" "}
                      <span className="ms-2 verticle-middle mt-1">
                        <img src="assets/images/whiteArrow.svg" alt="" />
                      </span>
                    </Link>
                  )}
                </div>
                {setting?.home_page_achivment == 1 && <div className="achivment">
                  <ul className="achievements_list">
                    <li>
                      <CountUp end={setting.mentors} duration={2}>
                        {({ countUpRef, start }) => (
                          <VisibilitySensor onChange={start}>
                            <span ref={countUpRef} />
                          </VisibilitySensor>
                        )}
                      </CountUp>
                      <strong>Mentors</strong>
                    </li>
                    <li>
                      <span>
                        <CountUp end={setting.mentees} duration={2}>
                          {({ countUpRef, start }) => (
                            <VisibilitySensor onChange={start}>
                              <span ref={countUpRef} />
                            </VisibilitySensor>
                          )}
                        </CountUp>
                        +
                      </span>
                      <strong>Mentees</strong>
                    </li>
                    <li>
                      <CountUp end={setting.organisations} duration={2}>
                        {({ countUpRef, start }) => (
                          <VisibilitySensor onChange={start}>
                            <span ref={countUpRef} />
                          </VisibilitySensor>
                        )}
                      </CountUp>
                      <strong>Organizations</strong>
                    </li>
                    <li>
                      <CountUp end={setting.countries} duration={2}>
                        {({ countUpRef, start }) => (
                          <VisibilitySensor onChange={start}>
                            <span ref={countUpRef} />
                          </VisibilitySensor>
                        )}
                      </CountUp>
                      <strong>Countries</strong>
                    </li>
                    <li>
                      <span>
                        <CountUp end={setting.mentoring_hours} duration={2}>
                          {({ countUpRef, start }) => (
                            <VisibilitySensor onChange={start}>
                              <span ref={countUpRef} />
                            </VisibilitySensor>
                          )}
                        </CountUp>
                        +
                      </span>
                      <strong>Mentoring Hours</strong>
                    </li>
                  </ul>
                </div>}
              </div>
            </Col>
            <Col md={5} className="order-1 order-md-2 pb-4 pb-md-0">
              {setting?.video_image_enable === "1" && (
                <div className="banner_video ">
                  <div className="play_box">
                    <img
                      src={setting?.video_image_path || playBox}
                      alt="video"
                      className="circle-image"
                    />
                    {setting?.video_link_enable === "1" && (
                      <button
                        className="btn_play" style={{ backgroundColor: "transparent" }}
                        onClick={() => setModalShow(true)}
                      >
                        <i className="fas fa-play"></i>
                      </button>
                    )}
                  </div>
                </div>
              )}
            </Col>
          </Row>
        </Container>
      </section>
      {setting?.homepagedata_description == "1" && (
        <section
          className="how_sec"
          dangerouslySetInnerHTML={prepareHtml(homePageData.description)}
        ></section>
      )}
      {setting?.latest_mentor_page_heading_enable === "1" && isSectionShow('Mentoring Engagement') && leaders?.length > 0 && (
        <section className="leader_sec">
          <Container>
            <div className="title text-start pb-0 space-bottom secondaryTitle">
              <Link to="/mentors">
                <div
                  dangerouslySetInnerHTML={prepareHtml(setting?.latest_mentor_page_heading?.replaceAll("\r\n", "<br>"))}
                />
              </Link>
            </div>
            <Slider {...leadersSilder} className="diversity">
              {leaders.map((item, key) => (
                <div key={item.id}>
                  <div className="leader_box text-center">
                    <div className="leader_img">
                      <img
                        src={item.image}
                        alt="women's leadership mentoring program"
                      />
                      {getFieldValueAndStatus('name') && <span className="leader_title">{item?.full_name}</span>}
                    </div>
                    <div className="leader_info2 text-start">
                      <div>
                        {getFieldValueAndStatus('name') && <span className="name">{item?.full_name}</span>}
                        {getFieldValueAndStatus('position') && <span className="profile">{item?.position ?? ""}</span>}
                        {getFieldValueAndStatus('organization') && <span className="experience">
                          {item.organization ?? ""}
                        </span>
                        }
                        {getFieldValueAndStatus('domains') && <span className="experience">{item?.main_area ?? ""}</span>}
                        {subdomainPath !== "simuat" && getFieldValueAndStatus('linkedin') && item?.linkedin && item?.linkedin !== 'undefined' && (
                          <div className="LinkedinLink">
                            <a
                              href={
                                item.linkedin.startsWith('http')
                                  ? item.linkedin
                                  : `https://${item.linkedin}`
                              }
                              className="newcustomelinked text-white m-0"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Linkedin Profile
                            </a>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </Container>
        </section>
      )}
      {setting?.domain_community_heading_enable === "1" && isSectionShow('Communities') && community.length > 0 && (
        <section className="communities_sec" id="communities_sec">
          <Container>
            <div className="title text-start pb-0 space-bottom secondaryTitle" dangerouslySetInnerHTML={prepareHtml(setting?.domain_community_heading?.replaceAll("\r\n", "<br>"))}>
            </div>
            <Slider {...communities} className=" ">
              {community.map((item, key) => (
                <div key={item.id}>
                  <div className="communities_info">
                    <button
                      onClick={(e) => joinGroupDetail(e, item.slug)}
                    >
                      {/* Image — clickable */}
                      <img
                        src={item.thumb_image}
                        alt="coaching for professional women"
                        className="community-img"
                      />
                      {/* Title and subtitle — clickable */}
                      <div className="p-3">
                        <h4 className="m-0 heading pb-2">{item.group_name}</h4>
                        <p className="m-0">{item.title}</p>
                      </div>
                    </button>
                    <div className="mx-1 p-3 border-top d-flex align-items-center justify-content-between flex-wrap row-gap-2">
                      <div className="members_tag">
                        <img
                          src="assets/images/memberTag.svg"
                          width="28px"
                          height="18px"
                          alt="member tag"
                        />
                        {item.member_count} Members
                      </div>
                      <Link
                        className="btn link_group ms-auto px-4"
                        to=""
                        onClick={(e) => joinGroupDetail(e, item.slug)}
                      >
                        Join Group
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </Container>
        </section>
      )}

      {isSectionEnabled('Home Page Content', 'Partners Sticker') && brand.length > 0 && (
        <section className="brand_sec">
          <Container>
            <div className="title text-center space-bottom secondaryTitle pb-3 pb-md-5 pe-0">
              {setting.partners_heading ? setting.partners_heading : 'Partnering Organizations and Institutions'}
            </div>
            <Slider {...Brand} >
              {/* {brand && */}
              {/* brand.length && */}
              {brand?.map((item, key) => {
                const isExpanded = expandedItems[key]
                return (
                  <div key={item.id} className="slider-card" >
                    <div className="slider-image-wrapper">
                      <img src={item?.image} alt={item?.title} className="image-size" />
                    </div>
                    <h4 className="slider-title">
                      {(() => {
                        let displayTitle = item?.title || "";
                        if (!isExpanded && displayTitle.length > 10) {
                          displayTitle = displayTitle.substring(0, 10) + "...";
                        }
                        return displayTitle;
                      })()}
                      {item?.title?.length > 10 && (
                        <button
                          className="view-toggle-button"
                          style={{ marginLeft: isExpanded ? '10px' : '2px' }}
                          onClick={() => toggleExpand(key)}
                        >
                          {isExpanded ? "View Less" : "View More"}
                        </button>
                      )}
                    </h4>

                  </div>
                )
              })}
            </Slider>
          </Container>
        </section>
      )}

      {/* achievements section */}
      {isSectionEnabled('Home Page Content', 'Testimonial') && testimonials.length > 0 && (
        <section className="leader_sec testimonial-slider">
          <Container>
            <div className="title text-start space-bottom position-relative pb-0 secondaryTitle">
              {setting.mentors_section_heading ? setting.mentors_section_heading : 'What our mentors and mentees are saying'}
            </div>
            <Slider {...TestimonialsSilder}>
              {testimonials.map((item, key) => (
                <div key={item.id}>
                  <div>
                    <div className="TestimonialsSilderBlock text-center testimonials-slider-div">

                      <div className="TestimonialsSilderWrap">
                        <ReadMoreParagraph text={item.description} maxLength={300} />
                        <div className="testimonialMember">
                          <div className="testimonisalPic">
                            <img
                              className="card-img-top"
                              src={item?.image || '/assets/images/no-image1.png'}
                              alt="coaching for professional women"
                            />
                          </div>
                          <h5>
                            {item.full_name} <br />
                            <span>
                              {item.position}, {item.organization}
                            </span>
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </Container>
        </section>
      )}

      {setting?.subscribe_heading_enable === "1" && isSectionShow('Subscription') && (
        <>
          <section className="newsletter_sec">
            <Container>
              <Row className="align-items-center">
                <Col md={6}>
                  <div className="d-flex align-items-center">
                    <div className="newsletter_icon">
                      {" "}
                      <img src="assets/images/subscribe.svg" alt="" />
                    </div>
                    <div className="newsletter_content ps-1 ps-md-4">
                      <p className="m-0" dangerouslySetInnerHTML={prepareHtml(setting?.subscribe_heading?.replaceAll("\r\n", "<br>"))} />
                    </div>
                  </div>
                </Col>
                <Col md={6} className="">
                  <Form
                    onSubmit={handleSubmit2(onSubmitEmail)}
                    className="banner_form my-4 mt-md-5 mb-md-4 signup_class ms-auto"
                  >
                    <Form.Group controlId="formEmail">
                      <FormControl
                        type="email"
                        placeholder="Email Address"
                        className={errors2?.email ? "formError mb-2" : ""}
                        {...register2("email", {
                          required: "Please enter your email address",
                          pattern: {
                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                            message: "Invalid email address",
                          },
                          maxLength: {
                            value: 50,
                            message: "Your email should contain max 50 characters",
                          },
                        })}
                        aria-invalid={errors2.email ? "true" : "false"}
                      />
                      <Button type="submit" title="Subscribe" className="btn btn-signup" />
                      {errors2.email && (
                        <span role="alert" className="err_msg text-danger">
                          {errors2.email.message}
                        </span>
                      )}
                    </Form.Group>
                  </Form>
                </Col>
              </Row>
            </Container>
          </section>
          <Subscribe />
        </>
      )}

      {modalShow && (
        <Video
          show={modalShow}
          setting={setting}
          onHide={() => setModalShow(false)}
        />
      )}

      {signupModalShow && (
        <Popup
          userInfo={userInfo}
          show={signupModalShow}
          handleSubmitCheckEmail={handleSubmitCheckEmail}
          onHide={() => setSignupModalShow(false)}
          setPopUpLoader={setPopUpLoader}
          popUpLoader={popUpLoader}

        />
      )}

      <PopupModalWithOk
        show={showPopup}
        onHide={() => setShowPopup(false)}
        message={popupMessage}
        showConfirm={false}
        staticBackdrop={true}
      />

      {ssoLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.35)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <i
            className="fas fa-spinner fa-spin"
            style={{
              fontSize: "60px",
              color: "#ffffff",
            }}
          />
        </div>
      )}

    </>
  );
};

Index.propTypes = {
  title: PropTypes.string.isRequired,
  actions: PropTypes.shape({
    getBrandData: PropTypes.func.isRequired,
    loadHomePageData: PropTypes.func.isRequired,
    loadLeaderData: PropTypes.func.isRequired,
    loadTestimonialsData: PropTypes.func.isRequired,
    loadCommunityData: PropTypes.func.isRequired,
    sendEmailForVerification: PropTypes.func.isRequired,
    getSettingData: PropTypes.func.isRequired
  }).isRequired,
  setting: PropTypes.shape({
    name: PropTypes.string,
    heading: PropTypes.string,
    sub_heading: PropTypes.string,
    punch_line: PropTypes.string,
    video_image_path: PropTypes.string,
    video_url: PropTypes.string,
    mentors: PropTypes.number,
    mentees: PropTypes.number,
    organisations: PropTypes.number,
    countries: PropTypes.number,
    mentoring_hours: PropTypes.number,
    latest_mentor_page_heading: PropTypes.string,
    domain_community_heading: PropTypes.string,
    partners_heading: PropTypes.string,
    mentors_section_heading: PropTypes.string,
    subscribe_heading: PropTypes.string,
    email_approval_required: PropTypes.number,
    module_data: PropTypes.array,
    mentor_fields_json: PropTypes.array,
    is_sso_enable: PropTypes.string,
    fusionAuthUrl: PropTypes.string,
    home_page_sub_hedding_enable: PropTypes.string,
    home_page_hedding_enable: PropTypes.string,
    punch_line_enable: PropTypes.string,
    home_page_achivment: PropTypes.string,
    video_image_enable: PropTypes.string,
    video_link_enable: PropTypes.string,
    homepagedata_description: PropTypes.string,
    latest_mentor_page_heading_enable: PropTypes.string,
    domain_community_heading_enable: PropTypes.string,
    subscribe_heading_enable: PropTypes.string,
    id: PropTypes.string,
    fusionauth_url: PropTypes.string
  }).isRequired,
  brand: PropTypes.array.isRequired,
  homePageData: PropTypes.shape({
    description: PropTypes.string,
  }).isRequired,
  leaders: PropTypes.array.isRequired,
  testimonials: PropTypes.array.isRequired,
  community: PropTypes.array.isRequired,
  userInfo: PropTypes.shape({
    id: PropTypes.number,
    role_id: PropTypes.string
  }).isRequired,
};

function mapStateToProps(state) {
  return {
    setting: state.setting,
    // Prioritize home slice data, fallback to old reducers
    brand: state.home?.brand || state.brand || [],
    leaders: state.home?.leaders || state.leaders || [],
    testimonials: state.home?.testimonials || state.testimonials || [],
    community: state.home?.community || state.community || [],
    isAuth: state.isAuth,
    homePageData: state.homePageData,
    userInfo: state.userInfo,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...userActions,
        ...settingActions,
        ...homePageActions,
        // Add Redux Toolkit slice actions
        loadLeaderData,
        loadTestimonialsData,
        loadCommunityData,
        getBrandData,
        sendEmailForVerification
      },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Index);
